import React from 'react';
import { AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useTranslation } from 'react-i18next';

export interface ValidationError {
  row: number;
  field: string;
  message: string;
}

interface ValidationErrorsProps {
  errors: ValidationError[];
}

export const ValidationErrors: React.FC<ValidationErrorsProps> = ({ errors }) => {
  const { t } = useTranslation();
  if (errors.length === 0) return null;

  return (
    <Alert variant="destructive">
      <AlertCircle className="h-4 w-4" />
      <AlertTitle>{t('onboarding.validationErrors.title', { count: errors.length })}</AlertTitle>
      <AlertDescription>
        <div className="mt-2 max-h-60 overflow-y-auto space-y-1">
          {errors.slice(0, 10).map((error, index) => (
            <div key={index} className="text-sm">
              {t('onboarding.validationErrors.row', { row: error.row })} <span className="font-mono">{error.field}</span> - {error.message}
            </div>
          ))}
          {errors.length > 10 && (
            <p className="text-sm italic mt-2">{t('onboarding.validationErrors.andMore', { count: errors.length - 10 })}</p>
          )}
        </div>
      </AlertDescription>
    </Alert>
  );
};
